import React from 'react';
import { validator } from './validator';
import { get, flatten } from 'lodash';
import store from './store';
import { defaultMessages } from '../libs/i18n/default';

export const objVal = (obj, path) => {
  return !!path.split('.').reduce((obj, prop) => {
    return obj && obj[prop] ? obj[prop] : undefined;
  }, obj)
}

export const getAge = dateString => {
  var today = new Date();
  var birthDate = new Date(dateString);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

export const formatDate = date => {
  if(Date.parse(date)){
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }
}

export const setElementValue = async(element, value, kind = 'input') => (
  await new Promise((resolve) => {
    if (!element) { return resolve() }
    let type = kind == 'input' ? window.HTMLInputElement.prototype : window.HTMLSelectElement.prototype
    let nativeInputValueSetter = Object.getOwnPropertyDescriptor(type, "value").set;
    nativeInputValueSetter.call(element, value);

    var ev = new Event(kind, { bubbles: true});
    element.dispatchEvent(ev)
    resolve()
  })
);

export const randomChars = (length) => {
  var result           = '';
  var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  var charactersLength = characters.length;
  for ( var i = 0; i < length; i++ ) {
     result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const blankOrValue = (val) => {
  return val == undefined ? '' : val;
}

export const isPresent = (string) => {
  return typeof string === 'string' && string.trim() !== '';
}

export const handleSelection = (original, newSelection) => {
  let newSelectionArray;

  if(original.includes(newSelection)) {
    newSelectionArray = original.filter(s => s !== newSelection);
  } else {
    newSelectionArray = [...original, newSelection];
  }
  return newSelectionArray
}

export const generateResidentElementObject = (field, resident) => {
  return {
    val: resident[field] || '',
    validationKey: `residents_${field}`
  }
}

export const generateRoomElementObject = (field, room) => {
  return {
    val: room[field] || '',
    validationKey: `rooms_${field}`
  }
}

export const overEighteenYearsAgo = (dateString) => {
  let eighteen_years_ago = new Date(new Date().getFullYear() - 18, new Date().getMonth(), new Date().getDay())
  let date = new Date(dateString)
  return date ? date < eighteen_years_ago : false
}

const buildNewObject = async(stateObject, key, val, resetDependentObject = true) => {
  const activeProfileElements = store.getState().user.guest.type.guest_profile_elements
  let newObject = {...stateObject[key]}
  val = resetDependentObject ? val : newObject.val
  let result = await validator(val, newObject.validationKey)
  newObject.val = val
  newObject.valid = get(result, 'valid')
  newObject.failedValidation = get(result, 'failedValidation')
  return newObject
}

const dependentFields = (stateObject, key) => (
  Object.keys(stateObject).filter(k => flatten([get(stateObject[k], 'dependentObj', '')]).includes(key))
)

export const changeState = async(stateObject, key, val, callback, resetDependentObject = true) => {
  let newObj = await buildNewObject(stateObject, key, val)
  callback({[key]: newObj})
  let newStateObj = {...stateObject, [key]: newObj}
  dependentFields(newStateObj, key).forEach(async(k) => {
    let newDependentObj = await buildNewObject(newStateObj, k, '', resetDependentObject)
    callback({[k]: newDependentObj})
  })
}

export const linkRenderer = ({ href, children }) => (
  <a href={href} target="_blank">{children}</a>
)

export const yesNoOptions = (formatMessage, useBooleanValues = true) => {
  return(
    <>
      <option value="" key="select">{formatMessage(defaultMessages.clientCommonYesNo)}</option>
      <option value={useBooleanValues ? 'true' : 'Yes'} key="Yes">{formatMessage(defaultMessages.clientCommonAffirmative)}</option>
      <option value={useBooleanValues ? 'false' : 'No'} key="No">{formatMessage(defaultMessages.clientCommonNegative)}</option>
    </>
  )
}

export const optionsFromArray = (options, formatMessage, key = 'key') => (
  [
    <option value="" key="select">{formatMessage(defaultMessages.clientCommonSelectsSelect)}</option>,
    ...options.map(f => (
      <option value={f[0]} key={`${key}_${f[0]}`}>{f[1]}</option>
    ))
  ]
)

export const camelize = (name) => (
  name.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => (
    index === 0 ? word.toLowerCase() : word.toUpperCase()
  )).replace(/\s+/g, '')
);
